<template>
    <div class="row g-3">
        <!-- NAGŁÓWEK ZAKŁADKI -->
        <div class="col-12 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 border-bottom pb-2 mb-2">
            <div>
                <div class="d-flex align-items-center gap-2">
                    <h6 class="fw-bold mb-0">Pasek przesłaniania, O firmie, Stopka</h6>
                    <!-- BADGE NIEZAPISANYCH ZMIAN -->
                    <span v-if="isDirty" class="badge bg-warning text-dark border border-warning">
                        <i class="bi bi-exclamation-triangle-fill me-1"></i>Niezapisane zmiany
                    </span>
                </div>
                <small class="text-muted">Zarządzanie sekcjami informacyjnymi oraz stopką serwisu</small>
            </div>
            <button type="button" class="btn btn-primary-dark d-flex align-items-center gap-2"
                :disabled="loading || saving || !isDirty" @click="saveData">
                <i class="bi bi-floppy"></i>
                <span>Zapisz zmiany</span>
            </button>
        </div>

        <!-- BLOK 1: PEŁNA SZEROKOŚĆ (Czerwony pasek zalet) -->
        <div class="col-12">
            <div class="card shadow-sm border-0 bg-body-tertiary">
                <div class="card-header bg-dark text-white fw-bold d-flex justify-content-between align-items-center">
                    <span>Blok 1</span>
                    <button type="button" class="btn btn-sm btn-outline-light d-flex align-items-center gap-1"
                        @click="openEditModal(0)">
                        <i class="bi bi-pencil-square"></i>
                        <span>Edytuj WYSIWYG</span>
                    </button>
                </div>
                <div class="card-body">
                    <label class="form-label fw-semibold small text-muted">Tytuł nagłówka</label>
                    <input type="text" class="form-control mb-3" v-model="form.blocks[0].title"
                        placeholder="np. DLACZEGO WARTO KUPIĆ U NAS" />

                    <label class="form-label fw-semibold small text-muted">Podgląd treści</label>
                    <div class="block-preview border rounded p-2 bg-white small"
                        v-html="form.blocks[0].content || '<span class=\'text-muted italic\'>Brak treści HTML</span>'">
                    </div>
                </div>
            </div>
        </div>

        <!-- BLOK 2: PEŁNA SZEROKOŚĆ (Informacje o firmie) -->
        <div class="col-12">
            <div class="card shadow-sm border-0 bg-body-tertiary">
                <div class="card-header bg-dark text-white fw-bold d-flex justify-content-between align-items-center">
                    <span>Blok 2</span>
                    <button type="button" class="btn btn-sm btn-outline-light d-flex align-items-center gap-1"
                        @click="openEditModal(1)">
                        <i class="bi bi-pencil-square"></i>
                        <span>Edytuj WYSIWYG</span>
                    </button>
                </div>
                <div class="card-body">
                    <label class="form-label fw-semibold small text-muted">Tytuł nagłówka</label>
                    <input type="text" class="form-control mb-3" v-model="form.blocks[1].title"
                        placeholder="np. INFORMACJE O FIRMIE" />

                    <label class="form-label fw-semibold small text-muted">Podgląd treści</label>
                    <div class="block-preview border rounded p-2 bg-white small"
                        v-html="form.blocks[1].content || '<span class=\'text-muted italic\'>Brak treści HTML</span>'">
                    </div>
                </div>
            </div>
        </div>

        <!-- BLOK 3: CZARNA STOPKA (Dwukolumnowa wewnątrz) -->
        <div class="col-12">
            <div class="card shadow-sm border-0 bg-body-tertiary">
                <div class="card-header bg-dark text-white fw-bold d-flex justify-content-between align-items-center">
                    <span>Blok 3</span>
                    <button type="button" class="btn btn-sm btn-outline-light d-flex align-items-center gap-1"
                        @click="openEditModal(2)">
                        <i class="bi bi-pencil-square"></i>
                        <span>Edytuj WYSIWYG</span>
                    </button>
                </div>
                <div class="card-body">
                    <label class="form-label fw-semibold small text-muted">Tytuł nagłówka</label>
                    <input type="text" class="form-control mb-3" v-model="form.blocks[2].title"
                        placeholder="np. STOPKA DOLNA" />

                    <label class="form-label fw-semibold small text-muted">Podgląd treści</label>
                    <div class="block-preview border rounded p-2 bg-white small"
                        v-html="form.blocks[2].content || '<span class=\'text-muted italic\'>Brak treści HTML</span>'">
                    </div>
                </div>
            </div>
        </div>


        <!-- PRZYCISK ZAPISU -->
        <div class="col-12 d-flex justify-content-end mt-4 pt-3 border-top">
            <button type="button" class="btn btn-primary-dark d-flex align-items-center gap-2"
                :disabled="loading || saving || !isDirty" @click="saveData">
                <i class="bi bi-floppy"></i>
                <span>Zapisz zmiany</span>
            </button>
        </div>
    </div>

    <!-- MODAL WYSIWYG Z SUMMERNOTE -->
    <div class="modal fade" id="footerBlockModal" tabindex="-1" aria-labelledby="footerBlockModalLabel"
        aria-hidden="true" ref="modalRef">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fw-bold" id="footerBlockModalLabel">
                        Edycja Bloku {{ editingIndex !== null ? editingIndex + 1 : '' }}: {{ activeModalBlock.title }}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body p-3">
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Tytuł sekcji</label>
                        <input type="text" class="form-control" v-model="activeModalBlock.title" />
                    </div>

                    <div class="mb-2">
                        <label class="form-label fw-semibold">Treść HTML (Summernote)</label>
                        <!-- ELEMENT ZAMONTOWANIA SUMMERNOTE -->
                        <div ref="editorRef"></div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Anuluj</button>
                    <button type="button" class="btn btn-primary-dark" @click="applyModalChanges">
                        Zastosuj zmiany
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- LOADER -->
    <AppLoader :show="loading || saving" :text="loaderText" />
</template>

<script setup>
import { ref, onMounted, nextTick, onBeforeUnmount, watch } from 'vue'
import apiClient from '@/api'
import { onBeforeRouteLeave } from 'vue-router'
import Modal from 'bootstrap/js/dist/modal'
import $ from 'jquery'
import { webAlert } from '@/utils/dialog'

// Wpięcie jQuery dla Summernote
window.jQuery = $
window.$ = $

// Polyfill dla usuniętej w nowszych jQuery metody $.now
if (!$.now) {
    $.now = () => Date.now()
}

import 'summernote/dist/summernote-lite.min.css'
import 'summernote/dist/summernote-lite.min.js'

import AppLoader from '@/components/AppLoader.vue'
import { showConfirm } from '@/utils/dialog'


const loading = ref(false)
const saving = ref(false)
const loaderText = ref('')

// Zmienne zarządzające stanem niezapisanych zmian
const isDirty = ref(false)
const isInitialLoading = ref(true)

const modalRef = ref(null)
const editorRef = ref(null)
let bsModalInstance = null

const editingIndex = ref(null)
const activeModalBlock = ref({
    title: '',
    content: ''
})

const form = ref({
    blocks: [
        {
            title: 'DLACZEGO WARTO KUPIĆ PRZEZ NASZ PORT',
            content: '<p>Treść paska z zaletami...</p>'
        },
        {
            title: 'INFORMACJE O FIRMIE',
            content: '<p>Głównym atutem naszej firmy jest kompleksowa obsługa Klientów...</p>'
        },
        {
            title: 'STOPKA DOLNA',
            content: `
                <div class="row">
                    <div class="col-12 col-md-6">
                        <h6>GODZINY OTWARCIA</h6>
                        <p>- Poniedziałek - Piątek: 9:00 - 17:00</p>
                        <p>- Sobota: 9:00 - 14:00</p>
                    </div>
                    <div class="col-12 col-md-6">
                        <h6>KONTAKT</h6>
                        <p>Auto Kutno sp. z o.o.<br>NIP: 5273008977<br>Tel: 608892613</p>
                    </div>
                </div>
            `
        }
    ]
})

// Watcher do śledzenia zmian w strukturze form
watch(
    form,
    () => {
        if (!isInitialLoading.value) {
            isDirty.value = true
        }
    },
    { deep: true }
)

// Ochrona nawigacji przy próbie wyjścia z zakładki
onBeforeRouteLeave(async (to, from, next) => {
    if (isDirty.value) {
        // Jeśli showConfirm zwraca true dla głównego przycisku:
        const stayAndSave = await showConfirm(
            'Masz niezapisane zmiany w menu. Czy chcesz pozostać na stronie i je zapisać?',
            {
                title: 'Niezapisane zmiany',
                confirmText: 'Zostań i zapisz', // Główny przycisk (po prawej)
                cancelText: 'Opuść bez zapisywania' // Poboczny/Anuluj (po lewej)
            }
        )

        if (stayAndSave) {
            next(false) // Blokujemy nawigację – użytkownik zostaje
        } else {
            next() // Pozwalamy wyjść
        }
    } else {
        next()
    }
})

// Przycisk do Summernote dodający podział 50% / 50% dla 3. bloku stopki
const createBootstrapGridButton = (context) => {
    const ui = $.summernote.ui
    const $button = ui.button({
        contents: '<i class="bi bi-layout-split"></i> 2 Kolumny (50 / 50)',
        click: () => {
            const gridHtml = `
                <div class="row my-2 p-2 border bg-light">
                    <div class="col-12 col-md-6 border p-2 bg-white">
                        <p><strong>Godziny otwarcia (Lewa strona)</strong></p>
                        <p>Wpisz treść...</p>
                    </div>
                    <div class="col-12 col-md-6 border p-2 bg-white">
                        <p><strong>Kontakt (Prawa strona)</strong></p>
                        <p>Wpisz treść...</p>
                    </div>
                </div>
                <p><br></p>
            `
            context.invoke('editor.pasteHTML', gridHtml)
        }
    }).render()

    $button.removeAttr('data-original-title title data-toggle')
    return $button
}

const initSummernote = () => {
    if (!editorRef.value) return

    $(editorRef.value).summernote('destroy')

    $(editorRef.value).summernote({
        height: 280,
        tooltip: false,
        toolbar: [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['table', ['table']],
            ['insert', ['link', 'bsGrid']],
            ['view', ['codeview']]
        ],
        buttons: {
            bsGrid: createBootstrapGridButton
        },
        callbacks: {
            onChange: (contents) => {
                activeModalBlock.value.content = contents
            }
        }
    })

    $(editorRef.value).summernote('code', activeModalBlock.value.content || '')
}

const openEditModal = (index) => {
    editingIndex.value = index
    activeModalBlock.value = { ...form.value.blocks[index] }

    if (!bsModalInstance && modalRef.value) {
        bsModalInstance = new Modal(modalRef.value)
    }
    bsModalInstance?.show()

    nextTick(() => {
        initSummernote()
    })
}

const applyModalChanges = () => {
    if (editorRef.value) {
        activeModalBlock.value.content = $(editorRef.value).summernote('code')
    }

    if (editingIndex.value !== null) {
        form.value.blocks[editingIndex.value] = { ...activeModalBlock.value }
    }

    bsModalInstance?.hide()
}

const loadData = async () => {
    loading.value = true
    isInitialLoading.value = true
    loaderText.value = 'Pobieranie danych stopki...'

    try {
        const response = await apiClient.post({ action: 'get-settings-footer' })

        const rawBlocks = response.data?.data?.blocks || response.data?.blocks

        if (Array.isArray(rawBlocks)) {
            form.value.blocks = rawBlocks.map((block, index) => {
                if (typeof block === 'string') {
                    return {
                        title: block,
                        content: ''
                    }
                }
                return {
                    title: block?.title || `Blok ${index + 1}`,
                    content: block?.content || ''
                }
            })
        }

        await nextTick()
        isDirty.value = false
        isInitialLoading.value = false
    } catch (error) {
        webAlert('Błąd podczas pobierania danych stopki.')
    } finally {
        loading.value = false
    }
}

const saveData = async () => {
    saving.value = true
    loaderText.value = 'Zapisywanie ustawień stopki...'

    try {
        const response = await apiClient.post(
            {
                action: 'save-settings-footer',
                blocks: form.value.blocks
            }
        )

        // Czyszczenie flagi edycji po pomyślnym zapisie
        isDirty.value = false

        webAlert(response.data)
    } catch (error) {
        webAlert('Błąd podczas zapisywania ustawień stopki.')
    } finally {
        saving.value = false
    }
}

onMounted(() => {
    loadData()
})

onBeforeUnmount(() => {
    if (editorRef.value) {
        $(editorRef.value).summernote('destroy')
    }
})
</script>

<style scoped>
.block-preview {
    min-height: 100px;
    max-height: 180px;
    overflow-y: auto;
}
</style>